import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import AudioContainer from '../../../common/audio/audioContainer';
import PassageLayout from '../../../common/layouts/passageLayout';
import ClozeText from '../../../common/components/ClozeText';
import GoButton from '../../../common/components/GoButton';
import TextPaneScroll from '../../../common/textPaneScroll/TextPaneScroll';
import { PRACTICE } from '../../../constants/assessmentItemType';
import { ApolloContext } from '../../../ApolloContextProvider';
import { ARIA_LABELS } from '../../../constants/text';
import { getScrollStepSize } from '../../mazeUtils';

class MazePracticeView extends React.Component {
    componentDidMount() {
        if (!this.props.isDataFetched) {
            this.props.fetchContent();
        } else {
            this.props.readPracticeScript();
        }
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.isDataFetched && this.props.isDataFetched) {
            this.props.readPracticeScript();
        }
    }

    componentWillUnmount() {
        this.props.cleanup();
    }

    getScrollableContent() {
        const textSegment = (
            <div className="lined-text">
                {this.props.paragraphs.map(paragraph => (
                    <ClozeText
                        isTabIndexActive={
                            !this.props.isScreenBlocked && !this.props.isScreenGreyedOut
                        }
                        key={paragraph.id}
                        text={paragraph.text}
                        questions={this.props.questions}
                        selectedResponses={this.props.selectedResponses}
                        onResponseSelected={this.props.onResponseSelected}
                    />
                ))}
            </div>
        );
        const buttonSegment = this.props.isNextButtonActive ? (
            <GoButton
                isEnabled={!this.props.isScreenBlocked}
                onClick={this.props.onNext}
                ariaLabel={ARIA_LABELS.GO_TO_NEXT_STEP}
            />
        ) : null;
        return [textSegment, buttonSegment];
    }

    render() {
        return (
            <PassageLayout
                class={classNames(`daze-measure ${PRACTICE}`, {
                    'is-extended-view': this.props.isExtendedView,
                })}
                isScreenBlocked={this.props.isScreenBlocked}
            >
                <AudioContainer />
                <div className="text-pane">
                    <div className="daze-text">
                        <div className="content">
                            <TextPaneScroll
                                scrollToSection="segment-part-one"
                                scrollStep={getScrollStepSize(
                                    this.props.isExtendedView,
                                    this.context.fontSizeScaleValue,
                                )}
                                isEnabled={this.props.isDataFetched}
                                content={this.getScrollableContent()}
                                isTabIndexDisabled={
                                    this.props.isScreenGreyedOut || this.props.isScreenBlocked
                                }
                            />
                        </div>
                    </div>
                </div>
            </PassageLayout>
        );
    }
}

MazePracticeView.propTypes = {
    isDataFetched: PropTypes.bool,
    isScreenBlocked: PropTypes.bool,
    isScreenGreyedOut: PropTypes.bool,
    isNextButtonActive: PropTypes.bool,
    paragraphs: PropTypes.arrayOf(
        PropTypes.shape({
            text: PropTypes.string.isRequired,
            id: PropTypes.string.isRequired,
        }),
    ),
    questions: PropTypes.array,
    selectedResponses: PropTypes.object,
    onResponseSelected: PropTypes.func,
    fetchContent: PropTypes.func,
    onNext: PropTypes.func,
    cleanup: PropTypes.func,
    readPracticeScript: PropTypes.func,
    isExtendedView: PropTypes.bool,
};

MazePracticeView.defaultProps = {
    isDataFetched: false,
    isScreenBlocked: false,
    isScreenGreyedOut: false,
    isNextButtonActive: false,
    paragraphs: [],
    questions: [],
    selectedResponses: {},
    onResponseSelected: () => {},
    fetchContent: () => {},
    onNext: () => {},
    cleanup: () => {},
    readPracticeScript: () => {},
    isExtendedView: false,
};

MazePracticeView.contextType = ApolloContext;

export default MazePracticeView;
